import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseHeader.module.scss'

import useModal from '@Hooks/myhouse/useModal'
import { handleNclick } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'
import { MY_HOUSE_BOARD_TYPE, MY_HOUSE_BOARD_WRITING_TYPE } from '@Root/contants/myhouse'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'

const cx = className.bind(style)

type Props = {
  title?: any
  boardType: MY_HOUSE_BOARD_TYPE
  writingType: MY_HOUSE_BOARD_WRITING_TYPE
}

const MyhouseHeader: React.FC<Props> = ({ title, boardType, writingType }: Props) => {
  const { open } = useModal()

  const handleCancelClick = (event: React.SyntheticEvent) => {
    handleNclick(boardType === MY_HOUSE_BOARD_TYPE.NOTICE ? NCLICK.MY_HOUSE.NOTICE_ENROL.CANCEL : NCLICK.MY_HOUSE.REVIEW_ENROL.CANCEL, event)

    open(writingType === MY_HOUSE_BOARD_WRITING_TYPE.ENROL ? MODAL_TYPE.CANCEL_WRITING : MODAL_TYPE.CANCEL_MODIFY)
  }

  return (
    <header className={cx('header')}>
      <div className={cx('inner')}>
        <h1 className={cx('title')}>{title}</h1>
        <button type="button" className={cx('button_cancel')} onClick={handleCancelClick}>
          취소
        </button>
      </div>
    </header>
  )
}

export default MyhouseHeader
